import React, {useRef} from 'react'
import clsx from 'clsx'
import styles from './SearchPlayer.module.scss'
import IconSearch from '@static/images/icon_search.svg'
import {t} from '@colonist/ui'

export interface SearchPlayerProps {
    className?: string
    placeholder?: string
    onSearch: (username: string) => void
    defaultValue?: string
    flatBottom?: boolean
    searchOnClear?: boolean
}

export const SearchPlayer = ({
    className,
    placeholder,
    onSearch,
    defaultValue = '',
    flatBottom = false,
    searchOnClear = false,
}: SearchPlayerProps) => {
    const inputRef = useRef<HTMLInputElement>(null)

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault()
        if(inputRef.current) onSearch(inputRef.current.value)
    }

    const handleIconClick = () => {
        if(inputRef.current) onSearch(inputRef.current.value)
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(searchOnClear && event.target.value === '') onSearch('')
    }

    return (
        <form className={clsx(styles.searchPlayerContainer, flatBottom && styles.flatBottom, className)} onSubmit={handleSubmit}>
            <input
                ref={inputRef}
                className={styles.searchInput}
                placeholder={placeholder ?? t('strings:popups.searchPlayer.title')}
                defaultValue={defaultValue}
                onChange={handleChange}
            />
            <img
                src={IconSearch}
                className={styles.searchIcon}
                onClick={handleIconClick}
                alt={placeholder ?? t('strings:popups.searchPlayer.title')}
            />
        </form>
    )
}
